import Dexie, { type Table } from "dexie";
import session from "./Session";
import type { Subscription, Notification, PrefRow } from "./types";

// Uses Dexie.js
// https://dexie.org/docs/API-Reference#quick-reference
//
// Notes:
// - As per docs, we only declare the indexable columns, not all columns

export interface NtfyDatabase extends Dexie {
  subscriptions: Table<Subscription, string>;
  notifications: Table<Notification, string>;
  prefs: Table<PrefRow, string>;
}

const createDatabase = (username: string | null | undefined): NtfyDatabase => {
  const dbName = username ? `ntfy-${username}` : "ntfy"; // IndexedDB database is based on the logged-in user
  const db = new Dexie(dbName) as NtfyDatabase;

  db.version(3).stores({
    subscriptions: "&id,baseUrl,[baseUrl+mutedUntil]",
    notifications: "&id,sequenceId,subscriptionId,time,new,[subscriptionId+new],[subscriptionId+sequenceId]",
    users: "&baseUrl,username",
    prefs: "&key",
  });
  // v4(2026-10-07, /api/v2): 다른 서버 계정(users)은 쓰지 않는다. 알림 행은 attachments[](여러 장)를 갖는다 —
  // 인덱스가 아닌 열이라 스키마는 그대로, 옛 행(attachment 하나)은 읽을 때 notificationAttachments() 가 맞춘다.
  db.version(4).stores({
    subscriptions: "&id,baseUrl,[baseUrl+mutedUntil]",
    notifications: "&id,sequenceId,subscriptionId,time,new,[subscriptionId+new],[subscriptionId+sequenceId]",
    users: null,
    prefs: "&key",
  });

  // When another connection (e.g., service worker or another tab) wants to upgrade,
  // close this connection gracefully to allow the upgrade to proceed
  db.on("versionchange", () => {
    console.log("[db] versionchange event: closing database");
    db.close();
  });

  return db;
};

const db = () => createDatabase(session.username());

export default db;
